import { create } from 'zustand';

// Minimal UI-facing sync state. Kept separate from the big useAdiaStore so
// sync state doesn't entangle with prayer state / CRUD flows.
//
// isInitialSyncing is set only in one specific situation: a SIGNED_IN event
// fires and the local store is currently empty (fresh install signing into
// an account with existing cloud prayers). It drives the reverent
// "Gathering your prayers…" indicator on PrayPage and auto-clears when
// syncPrayers() resolves or after a 15s safety timeout (see sync.ts).
interface SyncState {
  isInitialSyncing: boolean;
  setInitialSyncing: (value: boolean) => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  isInitialSyncing: false,
  setInitialSyncing: (value) => set({ isInitialSyncing: value }),
}));
